import React, { useRef, useState } from "react";
import ModalJson from "../../Configs/JSON/DependentModal.json";
import "../../styles/calculator/DependentModal.less";
import GenericModal from "../Common/GenericModal";
import CircleIcon from "../Common/CircleIcon";
import GenericButton from "../Common/GenericButton";
import { observer } from "mobx-react";
import FormStore from "../../Configs/Store/forms";
import getUserDataJSON from "../../Configs/JSON/UserData";
import { Form, Input } from "antd";
import RadioGroup from "../Common/RadioGroup";
import calculatorForm from "../../Configs/JSON/calculatorForm.json";
import { UserInput } from "../QuoteScreen/QuoteAPI";
import { ageValidation } from "../../Configs/Validator/FormValidations";
import Inputmask from "inputmask";
import { BlowFishReact } from "../Common/CommonFunctions";
import closeIconSM from "../../assets/closeiconnew.svg";

const DependentModal = observer((props) => {
  const [calcJourneyFormRef] = Form.useForm();
  const [ctaDisabled, setctaDisabled] = useState(false);

  const toggleProsperGender = async (e) => {
    var value = e.target.value;
    await FormStore.setCalcProspersGender(value);
    UserInput("p_gender", value, "", "");
    console.warn("Prosper's Gender :", FormStore.calc_prospersgender);
  };

  const dobInput = useRef({});
  const DateBoi = async (e) => {
    if (e !== null) {
      Inputmask("99/99/9999", {
        placeholder: "DD/MM/YYYY",
        prefillYear: false,
      }).mask(e.target);
    }
  };

  const inputWithMaskOnChange = (e) => {
    var value = e.target.value;
    calculateAge(value);
    FormStore.setCalcProspersDob(value);
    console.info("AgeOnChange :", value);
  };

  const inputWithMaskOnPaste = (e) => {
    var value = e.target.value;
    calculateAge(value);
    FormStore.setCalcProspersDob(value);
    console.warn("AgeOnPaste :", value);
  };

  const calculateAge = async (value) => {
    var min = 18;
    var max = 50;
    var flag = await ageValidation(value, min, max);
    console.info("Age Validation :", flag);
    await FormStore.setCalcProspersAge(flag.age);
  };

  const focusErrorField = async (error) => {
    try {
      var field = error["errorFields"][0]["name"][0];
      if (field === "ageItem") {
        dobInput.current.focus();
      }
    } catch (e) {
      console.error(e);
    }
    console.info("Error Valdiation :", field);
  };

  const submitJourney = () => {
    setctaDisabled(true);
    const SandGRef = props.submitRef;
    let UserDataJSON = getUserDataJSON();
    window.demoJson = UserDataJSON;
    window.UserDataJSON = UserDataJSON;
    UserDataJSON = btoa(BlowFishReact(true, "", UserDataJSON));
    document.getElementById("bolData").value = UserDataJSON;
    SandGRef.action = window.location.href.includes("testing")
      ? "https://buyuat.iprulifeinsurance.com/digiuatnew/PartnerIntegration.htm"
      : "https://buy.icicilife.com/buy/PartnerIntegration.htm";
    // setTimeout(() => {
    //   FormStore.setDependentJourney(false);
    //   setctaDisabled(false)
    //   SandGRef.submit()
    // }, 2000);
    setctaDisabled(false);
    //Call Suitability
    window.OpenSuitabilityPop();
    window.proceedToAppform = () => {
      setctaDisabled(true);
      SandGRef.submit();
    };
  };

  return (
    <>
      <GenericModal
        visibleState={FormStore.calc_dependentJourney}
        updateVisibility={() => FormStore.setDependentJourney(false)}
        closeIcon={<CircleIcon iconUrl={closeIconSM} />}
        rootClassAntCustom={"DependentModal"}
        showButton={false}
        buttonText={ModalJson["buttonText"]}
        // buttonStyle={"OKButton"}
        buttonWrapper={"calculateFormDiv"}
        buttononClick={submitJourney}
        component={
          <div className="contentWrap">
            <div className="SectionTitle">{ModalJson["modalTitle"]}</div>

            <div className="dependentForm">
              <Form
                layout={"vertical"}
                onFinish={submitJourney}
                onFinishFailed={focusErrorField}
                form={calcJourneyFormRef}
                initialValues={{
                  prospersgender: FormStore.calc_prospersgender,
                }}
              >
                <Form.Item
                  name="prospersAgeItem"
                  className={"CalculatorItem_DOB"}
                  validateFirst={true}
                  rules={[
                    {
                      required: true,
                      message: "Please enter date of birth.",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        var prospersAgeItem = getFieldValue("prospersAgeItem");
                        if (
                          prospersAgeItem <= 0 ||
                          prospersAgeItem === undefined
                        ) {
                          return Promise.reject("Please enter date of birth.");
                        } else if (FormStore.calc_prospersage === -1) {
                          return Promise.reject("Enter valid date of birth");
                        } else if (FormStore.calc_prospersage === -2) {
                          var min = 18;
                          var max = 50;
                          return Promise.reject(
                            `This option is available only for age between ${min} to ${max} years.`,
                          );
                        } else {
                          console.warn(
                            "Value prospersAgeItem :",
                            prospersAgeItem,
                          );
                          UserInput(
                            "p_age",
                            FormStore.calc_prospersage,
                            "",
                            "",
                          );
                          UserInput("p_dob", prospersAgeItem, "", "");
                          return Promise.resolve();
                        }
                      },
                    }),
                  ]}
                  label={
                    <div className="dobIncomeTitle">{`Your Date of Birth`}</div>
                  }
                >
                  <Input
                    className={`js-dobInput prosper-dobInput`}
                    type={"tel"}
                    ref={dobInput}
                    placeholder={"DD/MM/YYYY"}
                    onFocus={DateBoi}
                    onChange={inputWithMaskOnChange}
                    onPaste={inputWithMaskOnPaste}
                    // disabled={disableQData}
                    suffix={
                      <span
                        className={`xxYears ${FormStore.calc_prospersdob && Math.sign(FormStore.calc_prospersage) === 1 ? "Valid" : "Invalid"}`}
                      >
                        {FormStore.calc_prospersage + " Years old"}
                      </span>
                    }
                  />
                </Form.Item>

                <RadioGroup
                  className="prospersgender"
                  formName={"prospersgender"}
                  styleName="radioGender"
                  formClass={"CalculatorItem_Gender"}
                  type={1}
                  dynamicTitle={`Your Gender`}
                  jsonData={calculatorForm["gender"]}
                  reverse={true}
                  // propValue={FormStore.calc_prospersgender}
                  onChange={toggleProsperGender}
                  condition={FormStore.calc_buyingFor !== "Self" ? "" : ""}
                />

                <GenericButton
                  isDisabled={ctaDisabled}
                  title={"Calculate Premium"}
                  className="calculateFormDiv"
                />
              </Form>
            </div>
          </div>
        }
      />
    </>
  );
});

export default DependentModal;
